export default __webpack_public_path__ + "static/media/rhenus-rr.9fac7f66.svg";